import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';

import {Pagination} from '../pagination';

const InitialPage = 1;
const InitialTotalCount = 0;
const VisiblePageCount = 5;

@Component({
    selector: 'app-simple-pagination',
    templateUrl: './simple-pagination.component.html',
    styleUrls: ['./simple-pagination.component.scss']
})
export class SimplePaginationComponent implements OnInit, OnChanges {
    public totalPageCount: number;
    public visiblePageCount: number; // give an odd number
    public visiblePages: number[];

    @Input() currentPage: number;
    @Input() pageSize: number;
    @Input() totalItemsCount: number;

    @Output() currentPageChange: EventEmitter<number>;

    constructor() {
        this.pageSize = Pagination.defaultItemsPerPage;
        this.totalItemsCount = InitialTotalCount;

        this.currentPageChange = new EventEmitter<number>();

        this.totalPageCount = 0;
        this.visiblePageCount = VisiblePageCount;
        this.visiblePages = [];
    }

    ngOnInit(): void {
        this.calculateVisiblePages();

        this.currentPage ??= InitialPage;
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.currentPage || changes.pageSize || changes.totalItemsCount) {
            this.calculateTotalPageCount();
            this.calculateVisiblePages();
        }
    }

    calculateTotalPageCount() {
        this.totalPageCount = Math.ceil(this.totalItemsCount / this.pageSize);
    }

    calculateVisiblePages() {
        this.calculateTotalPageCount();

        let start = Math.max(2, this.currentPage - (Math.floor(this.visiblePageCount / 2)));
        let end = Math.min(this.totalPageCount - 1, this.currentPage + (Math.floor(this.visiblePageCount / 2)));

        const expectedDifference = this.visiblePageCount - 1;
        const currentDifference = end - start;

        if (currentDifference < expectedDifference) { // probably we are close to end on one side, try to add pages from other side
            const amountToIncrease = expectedDifference - currentDifference;

            if (start === 2) {
                end = Math.min(end + amountToIncrease, this.totalPageCount - 1);
            } else if (end === this.totalPageCount - 1) {
                start = Math.max(2, start - amountToIncrease);
            } // else total count is less than visible page count
        }

        this.visiblePages = [];

        for (let i = start; i <= end; i++) {
            this.visiblePages.push(i);
        }
    }

    isNavigatePreviousChunkVisible() {
        return this.visiblePages.length && this.visiblePages[0] > 2;
    }

    isNavigateNextChunkVisible() {
        return this.visiblePages.length && this.visiblePages[this.visiblePages.length - 1] < this.totalPageCount - 1;
    }

    navigatePreviousChunk() {
        this.go(this.currentPage - Math.floor(this.visiblePageCount / 2));
    }

    navigateNextChunk() {
        this.go(this.currentPage + Math.floor(this.visiblePageCount / 2));
    }

    go(pageNumber: number) {
        const newPage = Math.min(Math.max(1, pageNumber), this.totalPageCount);

        this.currentPage = newPage;
        this.calculateVisiblePages();
        this.currentPageChange.emit(this.currentPage);
    }
}
